var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLnIcon = function SvgLnIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.658 0A3.34 3.34 0 0140 3.342v33.316A3.34 3.34 0 0136.658 40H3.342A3.34 3.34 0 010 36.658V3.342A3.34 3.34 0 013.342 0h33.316zm-9.62 15c-2.818 0-4.753 1.236-5.627 2.68l-.16.292V15.25h-5.417v19.167h5.833v-9.285c0-3.111 1.146-5.09 3.9-5.09 1.881 0 2.681 1.647 2.76 4.588l.007.503v9.284h5.833V23.83c0-5.716-1.367-8.831-7.13-8.831zm-15.37 0H5.833v19.167h5.833V15zM8.75 5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z",
    fill: "#1AA35C"
  })));
};
export default SvgLnIcon;